const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/logout',
  '/analisi-acqua',
  '/embed-cases',
];

export default PUBLIC_ROUTES;